export enum Scenario {
  intro = 'intro',
  profile = 'profile',
  sidebar = 'sidebar',
  video = 'video',
}
